// Compliance pricing plans data
// This file is kept separate from the component to allow server-side usage

export interface CompliancePricingPlan {
  stage: string;
  name: string;
  price: string;
  period?: string;
  description: string;
  subtitle?: string;
  tagline?: string;
  includes: string[];
  notIncluded?: string[];
  badge?: string;
  featured?: boolean;
  cta: string;
}

export const compliancePricingPlans: CompliancePricingPlan[] = [
  {
    stage: 'Start',
    name: 'Compliance Readiness Assessment',
    price: '$6,995',
    period: 'one-time',
    description: 'For organizations beginning their compliance journey.',
    subtitle: 'HIPAA, SOC 2, PCI DSS, or similar frameworks.',
    includes: [
      'Framework-specific risk and gap assessment',
      'Prioritized remediation roadmap',
      '12-month access to compliance assessment platform',
      'Policy gap review (missing or outdated policies)'
    ],
    notIncluded: ['Ongoing advisory or policy drafting support'],
    featured: false,
    cta: 'Get Started'
  },
  {
    stage: 'Grow',
    name: 'Ongoing Compliance Advisory',
    price: '$2,995',
    period: 'per month',
    description: 'For growing organizations that need expert guidance and recurring compliance reporting.',
    subtitle: '',
    badge: 'Most Popular',
    includes: [
      'Everything in Readiness Assessment',
      'Quarterly reviews and executive-level reporting',
      'Annual risk analysis refresh',
      'Policy development and updates',
      'Continuous compliance coaching and support'
    ],
    featured: true,
    cta: 'Get Started'
  },
  {
    stage: 'Automate',
    name: 'Continuous Compliance & Monitoring',
    price: '$3,995',
    period: 'per month',
    tagline: 'Audit-Ready Automation',
    description: 'For established businesses requiring continuous monitoring and automated evidence collection.',
    includes: [
      'Everything in Ongoing Compliance Advisory',
      'Automated evidence collection and reporting',
      'Continuous control monitoring with proactive alerts',
      'HR, IT, and ticketing integrations',
      'Streamlined audit preparation for SOC 2 Type 2 and similar frameworks'
    ],
    featured: false,
    cta: 'Get Started'
  },
  {
    stage: 'Self-Manage',
    name: 'Platform-Only Access',
    price: '$4,499',
    period: 'per year',
    description: 'For in-house teams that want to manage compliance independently with our platform.',
    includes: [
      'Self-service tracking, reporting, and dashboards',
      'Framework templates and documentation checklists',
      'Progress monitoring tools',
      '1-hour onboarding session'
    ],
    notIncluded: ['Advisory or policy drafting support'],
    featured: false,
    cta: 'Get Started'
  }
];
